import UserInfo from './UserInfo.jsx';

export {UserInfo}



// WEBPACK FOOTER //
// ./components/users/sub-view/user-info/index.js